import React, {Component} from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';
import UserLayout from '../../layout/UserLayout';
import {AuthRoute} from "../../App";
import {connect} from "react-redux";
import googleAuth from "./googleAuth";
import security from "./security";
import login from './login';

class User extends Component {
  render() {
    const {match, isLoggedIn} = this.props;
    return (
      <UserLayout>
        <Switch>
          <Redirect exact from={`${match.url}/`} to={`${match.url}/login`}/>
          <Route path={`${match.url}/login`} component={login}/>
          <Route path={`${match.url}/googleAuth`} component={googleAuth}/>
          <AuthRoute path={`${match.url}/security`} isLoggedIn={isLoggedIn} component={security}/>
          <Redirect to="/error"/>
        </Switch>
      </UserLayout>
    );
  }
}

const mapStateToProps = ({authUser}) => {
  const {isLoggedIn} = authUser;
  return {isLoggedIn};
};

export default connect(mapStateToProps)(User);
